import cx from "components/src/utils/cx";
import { MarketRowScrollableSelections } from "./MarketRowScrollableSelections";
import React from "react";
import { MarketCompetitor } from "./MarketCompetitor";

const handleStopPropagation = (e) => {
  e.stopPropagation();
};

export function MarketRowScrollable({
  useSingleSelection,
  dataFilterGroup,
  marketId,
  rest,
  wrapperRef,
  marketCompetitorProps,
  selections,
  marketButtonData,
  randIdString,
  initialScrolledSelectionIndex,
  interactedTemplateState,
  containerSize,
  forceScrollableNav,
  scrollableAutoCenterSelected,
}) {
  const selLen = selections?.length;

  const selectedIndex = scrollableAutoCenterSelected
    ? selections?.findIndex(s =>
        marketButtonData?.selectedSelectionIds?.includes(s.id) ||
        marketButtonData?.isSelectedBuilder?.(s.id)
      ) ?? -1
    : -1;

  const sliderInitialIndex =
    (selectedIndex > -1
      ? selectedIndex
      : typeof initialScrolledSelectionIndex === "number" || typeof initialScrolledSelectionIndex === "string"
        ? Number(initialScrolledSelectionIndex)
        : Math.floor(selLen / 2)) + 1;

  const breakpoint = 643 //735;
  const isDesktop = containerSize?.width > breakpoint ? true : false;

  const hasScrolling = selLen > 3 || !isDesktop;
  
  const showNav = isDesktop || !!forceScrollableNav;

  return (
    <div
      className={`cui__market-row-scrollable cui-flex`}
      data-filter-group={!useSingleSelection ? dataFilterGroup : null}
      id={marketId || randIdString.current}
      {...rest}
      onClick={handleStopPropagation}
    >
      <div
        className={cx({
          "cui-w-[calc(100%-380px)]": isDesktop,
          "cui-w-[calc(100%-280px)]": !isDesktop && showNav,
          "cui-w-[calc(100%-160px)]": !isDesktop && !showNav,
        }, "cui-flex cui-items-center")}
        ref={wrapperRef}
      >
        <MarketCompetitor {...marketCompetitorProps} />
      </div>
      <div
        className={cx({
          "cui-min-w-[410px] cui-w-[410px] cui-max-w-[410px]": isDesktop,
          "cui-w-[280px] cui-min-w-[280px] cui-max-w-[280px]": !isDesktop && showNav,
          "cui-w-[178px] cui-min-w-[178px] cui-max-w-[178px]": !isDesktop && !showNav,
        }, "cui-box-border cui-flex cui-relative cui-overflow-hidden")}
      >
        <MarketRowScrollableSelections
          isDesktop={isDesktop}
          showNav={showNav}
          hasScrolling={hasScrolling}
          sliderInitialIndex={sliderInitialIndex}
          selections={selections}
          marketButtonData={marketButtonData}
        />
      </div>
    </div>
  );
}
